export const PurchasesDataUrl = (): string => '/ClubLink/GetCustomerFactor';
